import React from 'react';
import T from 'prop-types';
// components
import AgentActivity, { affectRerenderKeys } from './AgentActivity/AgentActivity';
// regional date handling
import { connect } from 'react-redux';
import { getCurrentCountryCode } from 'selectors/regionalDateSelectors';
import { formatDateForUser } from 'utils/regionalDateHelper';
// hoc
import withActivityController from './hoc/withActivityController';

// EveryPig Agent workflow #2: pre-market load weekend warning
const AgentPremarketLoadWarningActivity = ({ countryCode, ...props }) => {
  const loadDate = formatDateForUser(props.activity.additional_data?.scheduled_load_date, countryCode);

  return (
    <AgentActivity
      {...props}
      titleId="component.agentPremarketLoadWarningActivity.title"
      textId="component.agentPremarketLoadWarningActivity.text"
      textValues={{ loadDate }}
    />
  );
};

AgentPremarketLoadWarningActivity.propTypes = {
  activity: T.object.isRequired,
  countryCode: T.string,
};

const ConnectedComponent = connect(
  (state) => ({
    countryCode: getCurrentCountryCode(state),
  })
)(AgentPremarketLoadWarningActivity);

export default withActivityController(ConnectedComponent, { affectRerenderKeys });
